/**
 * 日付ユーティリティ。**すべてJST基準。**(yojitsu-system と共通の方式)
 * ブラウザのタイムゾーンに依存させないため、Intl で明示的に Asia/Tokyo を指定する。
 */
import type { DateStr, MonthStr } from './types';

const JST = 'Asia/Tokyo';

const jstFormatter = new Intl.DateTimeFormat('en-CA', {
  timeZone: JST,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

/** Date を JST の 'YYYY-MM-DD' に変換する */
export function toDateStr(d: Date): DateStr {
  // en-CA は 'YYYY-MM-DD' 形式で出力される
  return jstFormatter.format(d);
}

/** 今日(JST)の 'YYYY-MM-DD' */
export function todayStr(): DateStr {
  return toDateStr(new Date());
}

/** 'YYYY-MM-DD' → 'YYYY-MM' */
export function toMonth(date: DateStr): MonthStr {
  return date.slice(0, 7);
}

/** 'YYYY-MM-DD' が妥当か(存在しない日付も弾く) */
export function isValidDateStr(v: string): boolean {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(v)) return false;
  const [y, m, d] = v.split('-').map(Number) as [number, number, number];
  const dt = new Date(Date.UTC(y, m - 1, d));
  return dt.getUTCFullYear() === y && dt.getUTCMonth() === m - 1 && dt.getUTCDate() === d;
}

const WEEKDAYS = ['日', '月', '火', '水', '木', '金', '土'] as const;

/** 'YYYY-MM-DD' → '(木)' のような曜日表記 */
export function weekdayLabel(date: DateStr): string {
  const d = new Date(`${date}T00:00:00`);
  return Number.isNaN(d.getTime()) ? '' : `(${WEEKDAYS[d.getDay()]})`;
}

/** 'YYYY-MM-DD' → 'YYYY/MM/DD'(一覧表示用) */
export function toDateLabel(date: DateStr | null): string {
  return date ? date.replaceAll('-', '/') : '—';
}

/** FirestoreのTimestampを「YYYY/MM/DD」表示にする。未設定は「—」 */
export function tsToDateLabel(ts: unknown): string {
  if (!ts || typeof (ts as { toDate?: unknown }).toDate !== 'function') return '—';
  const d = (ts as { toDate: () => Date }).toDate();
  return `${d.getFullYear()}/${String(d.getMonth() + 1).padStart(2, '0')}/${String(d.getDate()).padStart(2, '0')}`;
}
